import Module from '../../Module';
import { Category, Product } from '../';

class NodeService extends Module {
  get baseURL() {
    return '/api/v1/nodes'
  }

  // initMock(handler) {
  //   mock(this.handler)
  // }

  /**
   * parse array of nodes
   * @param {Array} nodes 
   */
  parseNodes(nodes) {
    if (!nodes) return []

    return nodes.map(node => {
      return this.parseNode(node);
    });
  };

  parseCategoryNodes(categoryNodes) {
    if (!categoryNodes) return []

    return categoryNodes.map(categoryNode => {
      return this.parseCategoryNode(categoryNode);
    });
  }

  parseCategoryNode(categoryNode) {
    return {
      id: categoryNode.id,
      category: categoryNode.category ? this.parseCategory(categoryNode.category) : null,
    }
  }

  parseCategory(category) {
    return {
      id: category.id,
      title: category.title,
    }
  }

  parseProductParents(nodes) {
    if (!nodes) return [];

    return nodes.map(node => {
      return {
        id: node.id,
        childrenType: node.ownerType,
        category: {
          title: node.title
        }
      }
    })
  }

  /**
   * parse object of node
   * @param {Object} node
   */
  parseNode(node) {
    return {
      childrenType: node.childrenType,
      id: node.id,
      nodes: node.nodes,
      ownerId: node.ownerId,
      ownerType: node.ownerType,
      parentId: node.parentId,
      category: node.category ? Category.parseCategory(node.category) : null,
      product: node.product ? Product.parseProduct(node.product) : null,
    }
  }

  parseBrands(brands) {
    if(!brands) return []

    return brands.map(brand => {
      return this.parseBrand(brand)
    })
  }

  parseBrand(brand) {
    return {
      id: brand.brandId,
      name: brand.brandname
    }
  }

  getNode(id, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}/${id}/children`, {
          params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                nodes: this.parseNodes(data.nodes),
                current: data.current,
                parent: data.parent
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          });
    });
  };

  getNodeProduct(id, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}/${id}/products`, {
          params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                nodes: this.parseNodes(data.productNodes),
                categoryNodes: data.categoryNodes ? this.parseCategoryNodes(data.categoryNodes) : null,
                current: data.currentNode ? data.currentNode.category ? data.currentNode.category.title : null : null,
                parent: data.currentNode ? data.currentNode.parent ? data.currentNode.parent.category ? data.currentNode.parent.category.title : null : null : null,
                productParents: data.productParents ? this.parseProductParents(data.productParents) : null,
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          });
    });
  };

  getNodeBrands(id, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}/${id}/brands`, {
          params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                brands: this.parseBrands(r.data.brands)
              }))
            )
          })
          .catch(e => {
            reject(e)
          });
    });
  };
}

export default new NodeService()
